import { langs } from "helpers/lang";
import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ProjectRoutes from "./ProjectRoutes";

const Page: React.FC = () => {
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASE_RELATIVE_ROUTES}>
      <Routes>
        <Route path={`/${langs.en}/*`} element={<ProjectRoutes locale={langs.en} />} />
        <Route path={`/${langs.es}/*`} element={<ProjectRoutes locale={langs.es} />} />
        <Route path="/*" element={<ProjectRoutes locale={langs.pt} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Page;
